<template>
  <v-form ref="form" >

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12">
        <v-autocomplete
          v-model="entry.varietyId"
          v-bind="getObject('varietyId')"
          label="Variedade"
          :items="extraData.accountContext.allVarietiesOfPeriod"
          item-value="id"
          item-text="title"
          @input="selectVariety"
          autocomplete="off"
          :disabled="readOnly"
        >
          <!-- :hint="consumedItemAdditionalInfo(entry.item)"
          persistent-hint -->
          <!-- <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>{{consumedItemAdditionalInfo(data.item)}}</v-list-item-subtitle>
            </v-list-item-content>
          </template> -->
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6">
        <v-autocomplete
          :disabled="!entry.varietyId || readOnly"
          v-model="entry.unitId"
          v-bind="getObject('unitId')"
          label="Unidade de Perda"
          :items="unitsList"
          item-value="id"
          item-text="name"
          :loading="unitListLoading"
          @input="selectUnit"
          autocomplete="off"
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('quantity')"
          :inputData.sync="entry.quantity"
          mask-type="currency_10d"
          label="Quantidade"
          :suffix="entry.unit ? entry.unit.name : ''"
          :disabled="!entry.unitId || readOnly"
          autocomplete="off"
          :key="quantityKey + 'quantityKey'"
          :hint="entry.unit ? (entry.unit.lossLimit >= 0 ? 'O limite máximo de perda é de ' + numberToDecimal(entry.unit.lossLimit) + ' ' + entry.unit.name: '') : ''"
          persistent-hint
        />
      </v-col>

    </v-row>
  </v-form>
</template>

<script>

import MultiSelect from "@shared_components/multi_select.vue";
import MaskedTextField from "@shared_components/masked_text_field.vue"
import gql from 'graphql-tag'
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      unitListLoading: false,
      unitsList: [],
      renderComponent: true,
      quantityKey: 0,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    periodLoss: Object, // usado só para verificar qual o tipo que vai consumir esse item
    isEdit: { // utilizado para definir se o form é de edição
      type: Boolean,
      default: false
    },
    originalEntry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MultiSelect: MultiSelect,
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    // console.log("consumed item", this.entry.item)
    // console.log("extra", this.extraData);
    if (this.entry.varietyId) {
      this.selectVariety();
    }
  },
  mounted() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    selectVariety: function() {
      // console.log("entry.variety", this.entry.variety);
      if (this.entry.varietyId) {
        this.entry.variety = this.extraData.accountContext.allVarietiesOfPeriod.find(obj => obj.id == this.entry.varietyId);
        this.unitListLoading = true;
        this.$apollo
          .query({
            query: AVAILABLE_UNITS_FOR_VARIETY_QUERY,
            fetchPolicy: "no-cache",
            variables: {
              periodId: this.periodLoss.periodId,
              varietyId: this.entry.varietyId
            }
          })
          .then(response => {
            // console.log("response dos packaging", response);
            this.unitsList = response.data.accountContext.allPeriodPlantingUnitsForVariety;
            if (this.unitsList.length == 1 && !this.entry.unitId) {
              this.entry.unitId = this.unitsList[0].id;
            }
            if (this.entry.unitId) {
              this.selectUnit();
            }
          })
          .catch(response => console.log(response))
          .finally(() => (this.unitListLoading = false));
      }
    },
    selectUnit: function() {
      this.entry.unit = this.unitsList.find(obj => obj.id == this.entry.unitId);
      // console.log("lossLimit", this.entry.unit.lossLimit)
      if (this.entry.unit.lossLimit != null || this.entry.unit.lossLimit == 0) {
        this.entryAttributes.quantity.rules = [];
        this.entryAttributes.quantity.rules.push(this.requiredRule);
        this.entryAttributes.quantity.rules.push(this.minRequiredRule);
        let limitQuantity = _.round(this.entry.unit.lossLimit, 2);
        // usado para contabilizar a quantidade já salva no edit
        if (this.isEdit) {
          limitQuantity = _.round(this.entry.unit.lossLimit + this.originalEntry.quantity, 2);
        }
        this.entryAttributes.quantity.rules.push(this.maxValueRule(limitQuantity));
        this.entry.unit.lossLimit = limitQuantity;
      }
    },
    clearFields: function() {
      this.forceRerender(this);
    },
  }
};

const AVAILABLE_UNITS_FOR_VARIETY_QUERY = gql `
  query ($periodId: ID!, $varietyId: ID!) {
    accountContext {
      allPeriodPlantingUnitsForVariety(periodId: $periodId, varietyId: $varietyId){
        id
        name
        lossLimit
      }
    }
  }
`;

</script>

<style scoped></style>
